/**
 * @generated SignedSource<<09bebbe5bf2b1c3b1fb5336ab9f4e8c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type superSplashQuery$data = {
  readonly liveWidget: {
    readonly style: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"superSplashLargeLiveWidget" | "superSplashLiveLiveWidget">;
  } | null | undefined;
  readonly " $fragmentType": "superSplashQuery";
};
export type superSplashQuery$key = {
  readonly " $data"?: superSplashQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"superSplashQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "edition"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "superSplashQuery",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "edition",
              "variableName": "edition"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "DESC",
            "field": "UPDATED_DATE"
          }
        }
      ],
      "concreteType": "LiveWidget",
      "kind": "LinkedField",
      "name": "liveWidget",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "style",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "superSplashLiveLiveWidget"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "superSplashLargeLiveWidget"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "b233623ab61838e0c8ab05ebc1040de2";

export default node;
